<template>
    <b-card no-body class="mt-4">
        <b-tabs
            pills
            card
            content-class="tab-content-custom"
            active-nav-item-class="font-weight-bold text-uppercase text-white"
        >
            <b-tab title="Dữ liệu mưa" active>
                <h3 class="text-center">So sánh lượng mưa tại một trạm theo thời gian</h3>
                <b-row align-v="center">
                    <b-col cols="2">
                        Chọn trạm:
                        <v-select
                            style="width: 150px"
                            v-model="selectedRainStation"
                            :options="listRainStation"
                            label="name"
                            placeholder="Chọn trạm"
                            :clearable="false"
                        >
                            <template v-slot:option="option">
                                {{ option.name.replace('Trạm đo mưa', '').replace('xã', '') }}
                            </template>
                            <template v-slot:selected-option="{ name }">
                                <span style="font-size: 12px">
                                    {{ name.replace('Trạm đo mưa', '').replace('xã', '') }}
                                </span>
                            </template>
                            <template v-slot:no-options="{ search, searching, loading }">
                                Không có dữ liệu
                            </template>
                        </v-select>
                    </b-col>
                    <b-col cols="6">
                        Chọn thời gian:
                        <br />
                        <RDateTimePicker @updateValue="onChangeRainStartDate" :type="'datetime'" />
                        <span class="mx-2">~</span>
                        <RDateTimePicker @updateValue="onChangeRainEndDate" :type="'datetime'" />
                    </b-col>
                    <b-col class="text-right">
                        <b-button
                            v-if="listRainDataShow.length"
                            class="float-right"
                            @click="exportReportByTime('rain')"
                            variant="success"
                            pill
                        >
                            <i class="fa fa-file-excel-o mr-2" />
                            Xuất báo cáo
                        </b-button>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <div v-if="!listRainDataShow.length" class="text-center">Không có dữ liệu</div>
                    <div v-else>
                        <Chart :listData="listRainDataShow" />
                    </div>
                </div>

                <h3 class="text-center">So sánh lượng mưa các trạm tại cùng một thời điểm</h3>
                <b-row align-v="center">
                    <b-col cols="6">
                        Chọn danh sách trạm:
                        <v-select
                            v-model="selectedListRainStation"
                            :options="listRainStation"
                            label="name"
                            placeholder="Chọn trạm"
                            :clearable="false"
                            multiple
                        >
                            <template v-slot:option="option">
                                {{ option.name.replace('Trạm đo mưa', '').replace('xã', '') }}
                            </template>
                            <template v-slot:selected-option="{ name }">
                                <span style="font-size: 12px">
                                    {{ name.replace('Trạm đo mưa', '').replace('xã', '') }}
                                </span>
                            </template>
                            <template v-slot:no-options="{ search, searching, loading }">
                                Không có dữ liệu
                            </template>
                        </v-select>
                    </b-col>
                    <b-col cols="6">
                        Chọn thời gian:
                        <br />
                        <RDateTimePicker @updateValue="onSelectRainDate" :type="'datetime'" />
                    </b-col>
                    <b-col class="text-right">
                        <b-button
                            v-if="listStationsRain.length"
                            class="float-right"
                            @click="exportReportByStation('rain')"
                            variant="success"
                            pill
                        >
                            <i class="fa fa-file-excel-o mr-2" />
                            Xuất báo cáo
                        </b-button>
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <div v-if="!listStationsRain.length" class="text-center">Không có dữ liệu</div>
                    <div v-else>
                        <Chart :listData="listStationsRain" :isComparedData="true" />
                    </div>
                </div>
            </b-tab>
            <b-tab title="Dữ liệu nước" lazy>
                <h3 class="text-center">So sánh mực nước tại một trạm theo thời gian</h3>
                <b-row align-v="center">
                    <b-col cols="2">
                        Chọn trạm:
                        <v-select
                            style="width: 150px"
                            v-model="selectedWaterStation"
                            :options="listWaterStation"
                            label="name"
                            placeholder="Chọn trạm"
                            :clearable="false"
                        >
                            <template v-slot:option="option">
                                {{ option.name.replace('Trạm đo mực nước', '').replace('xã', '') }}
                            </template>
                            <template v-slot:selected-option="{ name }">
                                <span style="font-size: 12px">
                                    {{ name.replace('Trạm đo mực nước', '').replace('xã', '') }}
                                </span>
                            </template>
                            <template v-slot:no-options="{ search, searching, loading }">
                                Không có dữ liệu
                            </template>
                        </v-select>
                    </b-col>
                    <b-col cols="6">
                        Chọn thời gian:
                        <br />
                        <RDateTimePicker @updateValue="onChangeWaterStartDate" :type="'datetime'" />
                        <span class="mx-2">~</span>
                        <RDateTimePicker @updateValue="onChangeWaterEndDate" :type="'datetime'" />
                    </b-col>
                    <b-col class="text-right">
                        <b-button
                            v-if="listWaterDataShow.length"
                            class="float-right"
                            @click="exportReportByTime('water')"
                            variant="success"
                            pill
                        >
                            <i class="fa fa-file-excel-o mr-2" />
                            Xuất báo cáo
                        </b-button>
                    </b-col>
                </b-row>

                <div class="mt-3">
                    <div v-if="!listWaterDataShow.length" class="text-center">Không có dữ liệu</div>
                    <div v-else>
                        <Chart :listData="listWaterDataShow" :isRainData="false" />
                    </div>
                </div>

                <h3 class="text-center">So sánh mực nước các trạm tại cùng một thời điểm</h3>
                <b-row align-v="center">
                    <b-col cols="6">
                        Chọn danh sách trạm:
                        <v-select
                            v-model="selectedListWaterStation"
                            :options="listWaterStation"
                            label="name"
                            placeholder="Chọn trạm"
                            :clearable="false"
                            multiple
                        >
                            <template v-slot:option="option">
                                {{ option.name.replace('Trạm đo mực nước', '').replace('xã', '') }}
                            </template>
                            <template v-slot:selected-option="{ name }">
                                <span style="font-size: 12px">
                                    {{ name.replace('Trạm đo mực nước', '').replace('xã', '') }}
                                </span>
                            </template>
                            <template v-slot:no-options="{ search, searching, loading }">
                                Không có dữ liệu
                            </template>
                        </v-select>
                    </b-col>
                    <b-col cols="6">
                        Chọn thời gian:
                        <br />
                        <RDateTimePicker @updateValue="onSelectWaterDate" :type="'datetime'" />
                    </b-col>
                    <b-col class="text-right">
                        <b-button
                            v-if="listStationsWater.length"
                            class="float-right"
                            @click="exportReportByStation('water')"
                            variant="success"
                            pill
                        >
                            <i class="fa fa-file-excel-o mr-2" />
                            Xuất báo cáo
                        </b-button>
                    </b-col>
                </b-row>
                <div class="mt-3">
                    <div v-if="!listStationsWater.length" class="text-center">Không có dữ liệu</div>
                    <div v-else>
                        <Chart
                            :listData="listStationsWater"
                            :isComparedData="true"
                            :isRainData="false"
                        />
                    </div>
                </div>
            </b-tab>
        </b-tabs>
    </b-card>
</template>
<script>
import { mapState, mapActions } from 'vuex';
import RDateTimePicker from '@/components/RDateTimePicker';
import Chart from '@/components/Chart';
import * as FileSaver from 'file-saver';
import * as XLSX from 'xlsx';
const EXCEL_TYPE =
    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet;charset=UTF-8';
const EXCEL_EXTENSION = '.xlsx';
export default {
    components: {
        RDateTimePicker,
        Chart
    },
    data() {
        return {
            listRainData: [],
            listWaterData: [],
            selectedRainStation: null,
            selectedWaterStation: null,
            rainStartTime: null,
            rainEndTime: null,
            waterStartTime: null,
            waterEndTime: null,
            listRainDataShow: [],
            listWaterDataShow: [],
            selectedListRainStation: null,
            selectedListWaterStation: null,
            rainSelectedDate: null,
            rainSelectedHour: null,
            waterSelectedDate: null,
            waterSelectedHour: null,
            listStationsRain: [],
            listStationsWater: []
        };
    },
    watch: {
        async selectedRainStation(value) {
            if (value) {
                this.listRainData = await this.getAnalyzeWater({
                    stationCode: value.code,
                    type: 'CURRENT_RAIN'
                });
                this.setListRain();
            }
        },
        async selectedWaterStation(value) {
            if (value) {
                this.listWaterData = await this.getAnalyzeWater({
                    stationCode: value.code,
                    type: 'CURRENT_HIGH'
                });
                this.setListWater();
            }
        },
        selectedListRainStation(value) {
            if (value) {
                this.getRainDataList();
            }
        },
        selectedListWaterStation(value) {
            if (value) {
                this.getWaterDataList();
            }
        }
    },
    computed: {
        ...mapState({
            listAllStation: (state) => state.station.items
        }),
        listRainStation() {
            return this.listAllStation.filter((item) => item.code.includes('F00'));
        },
        listWaterStation() {
            return this.listAllStation.filter((item) => item.code.includes('F01'));
        }
    },
    methods: {
        ...mapActions({
            getAnalyzeWater: 'station/getAnalyzeWater'
        }),
        onChangeWaterStartDate(value) {
            if (!value) return;
            this.waterStartTime = this.$moment(value).format('YYYY-MM-DD HH:mm');
            this.setListWater();
        },
        onChangeWaterEndDate(value) {
            if (!value) return;
            this.waterEndTime = this.$moment(value).format('YYYY-MM-DD HH:mm');
            this.setListWater();
        },
        onChangeRainStartDate(value) {
            if (!value) return;
            this.rainStartTime = this.$moment(value).format('YYYY-MM-DD HH:mm');
            this.setListRain();
        },
        onChangeRainEndDate(value) {
            if (!value) return;
            this.rainEndTime = this.$moment(value).format('YYYY-MM-DD HH:mm');
            this.setListRain();
        },
        onSelectRainDate(value) {
            if (!value) return;
            this.rainSelectedDate = this.$moment(value).format('DD/MM/YYYY');
            this.rainSelectedHour = this.$moment(value).hour();
            this.getRainDataList();
        },
        onSelectWaterDate(value) {
            if (!value) return;
            this.waterSelectedDate = this.$moment(value).format('DD/MM/YYYY');
            this.waterSelectedHour = this.$moment(value).hour();
            this.getWaterDataList();
        },
        async getWaterDataList() {
            let listData = [];
            if (!this.waterSelectedDate || !this.selectedListWaterStation.length) return;
            let response = await this.getAnalyzeWater({
                type: 'CURRENT_HIGH',
                hour: this.waterSelectedHour,
                date: this.waterSelectedDate
            });
            for (let i = 0; i < response.length; i++) {
                const element = response[i];
                for (let j = 0; j < this.selectedListWaterStation.length; j++) {
                    const station = this.selectedListWaterStation[j];
                    if (station.code === element.stationCode)
                        listData.push({
                            ...element,
                            name: station.name
                                .replace('Trạm đo mực nước', '')
                                .replace('xã', '')
                                .trim()
                        });
                }
            }
            this.listStationsWater = listData;
        },
        async getRainDataList() {
            let listData = [];
            if (!this.rainSelectedDate || !this.selectedListRainStation.length) return;
            let response = await this.getAnalyzeWater({
                type: 'CURRENT_RAIN',
                hour: this.rainSelectedHour,
                date: this.rainSelectedDate
            });
            for (let i = 0; i < response.length; i++) {
                const element = response[i];
                for (let j = 0; j < this.selectedListRainStation.length; j++) {
                    const station = this.selectedListRainStation[j];
                    if (station.code === element.stationCode)
                        listData.push({
                            ...element,
                            name: station.name.replace('Trạm đo mưa', '').replace('xã', '').trim()
                        });
                }
            }
            this.listStationsRain = listData;
        },
        setListRain() {
            let listData = [];
            if (!this.rainStartTime || !this.rainEndTime) return;
            for (let i = 0; i < this.listRainData.length; i++) {
                const element = this.listRainData[i];
                let date = `${element.date.split('/')[2]}-${element.date.split('/')[1]}-${
                    element.date.split('/')[0]
                }`;
                let dateTime = this.$moment(date)
                    .set('hour', element.hour)
                    .format('YYYY-MM-DD HH:mm');
                if (
                    (this.$moment(dateTime).isAfter(this.$moment(this.rainStartTime)) &&
                        this.$moment(dateTime).isBefore(this.$moment(this.rainEndTime))) ||
                    this.$moment(dateTime).isSame(this.$moment(this.rainStartTime)) ||
                    this.$moment(dateTime).isSame(this.$moment(this.rainEndTime))
                )
                    listData.push(element);
            }
            this.listRainDataShow = listData;
        },
        setListWater() {
            let listData = [];
            if (!this.waterStartTime || !this.waterEndTime) return;
            for (let i = 0; i < this.listWaterData.length; i++) {
                const element = this.listWaterData[i];
                let date = `${element.date.split('/')[2]}-${element.date.split('/')[1]}-${
                    element.date.split('/')[0]
                }`;
                let dateTime = this.$moment(date)
                    .set('hour', element.hour)
                    .format('YYYY-MM-DD HH:mm');
                if (
                    (this.$moment(dateTime).isAfter(this.$moment(this.waterStartTime)) &&
                        this.$moment(dateTime).isBefore(this.$moment(this.waterEndTime))) ||
                    this.$moment(dateTime).isSame(this.$moment(this.waterStartTime)) ||
                    this.$moment(dateTime).isSame(this.$moment(this.waterEndTime))
                )
                    listData.push(element);
            }
            this.listWaterDataShow = listData;
        },
        exportReportByTime(type) {
            const listData = type == 'rain' ? this.listRainDataShow : this.listWaterDataShow;
            let report = [];
            for (let i = 0; i < listData.length; i++) {
                const item = listData[i];
                let record = {
                    STT: i + 1,
                    'Thời gian':
                        item.hour < 10
                            ? `${item.date} 0${item.hour}:00`
                            : `${item.date} ${item.hour}:00`
                };
                if (type == 'rain') record['Lượng mưa(mm/h)'] = item.value;
                else record['Mực nước(m)'] = item.value;
                report.push(record);
            }
            if (type == 'rain')
                report.push({
                    'Tổng(mm/h)': _.reduce(
                        listData.map((item) => parseInt(item.value)),
                        (sum, n) => {
                            return sum + n;
                        },
                        0
                    )
                });
            else
                report.push({
                    'Trung bình(m)': (
                        _.reduce(
                            listData.map((item) => parseInt(item.value)),
                            (sum, n) => {
                                return sum + n;
                            },
                            0
                        ) / listData.length
                    ).toFixed(2)
                });
            const excelFileName = `Báo cáo ${type == 'rain' ? 'lượng mưa' : 'mực nước'} tại trạm ${
                listData[0].stationCode
            } theo thời gian `;
            this.saveAsExcelFile(report, excelFileName);
        },
        exportReportByStation(type) {
            const listData = type == 'rain' ? this.listStationsRain : this.listStationsWater;
            let report = [];
            for (let i = 0; i < listData.length; i++) {
                const item = listData[i];
                let record = {
                    STT: i + 1,
                    Trạm: item.name
                };
                if (type == 'rain') record['Lượng mưa(mm/h)'] = item.value;
                else record['Mực nước(m)'] = item.value;
                report.push(record);
            }
            if (type == 'rain')
                report.push({
                    'Tổng(mm/h)': _.reduce(
                        listData.map((item) => parseInt(item.value)),
                        (sum, n) => {
                            return sum + n;
                        },
                        0
                    )
                });
            else
                report.push({
                    'Trung bình(m)': (
                        _.reduce(
                            listData.map((item) => parseInt(item.value)),
                            (sum, n) => {
                                return sum + n;
                            },
                            0
                        ) / listData.length
                    ).toFixed(2)
                });
            const excelFileName = `Báo cáo ${
                type == 'rain' ? 'lượng mưa' : 'mực nước'
            } tại thời điểm ${listData[0].date} theo trạm `;
            this.saveAsExcelFile(report, excelFileName);
        },
        saveAsExcelFile(report, fileName) {
            let worksheet = XLSX.utils.json_to_sheet(report);
            worksheet['!cols'] = [{ wch: 5 }, { wch: 15 }, { wch: 15 }];
            const workbook = { Sheets: { data: worksheet }, SheetNames: ['data'] };
            const excelBuffer = XLSX.write(workbook, { bookType: 'xlsx', type: 'array' });
            const data = new Blob([excelBuffer], { type: EXCEL_TYPE });
            FileSaver.saveAs(data, fileName + EXCEL_EXTENSION);
        }
    }
};
</script>